import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import setupAxiosInterceptors from './interceptor';
import Login from "./screens/Login";
import dashboard from "./screens/Dashbord/Dashbord";
import demographic from "./screens/Dashbord/Demographic";
import ioT from "./screens/Dashbord/IoT";
import NavbarMenu from "./components/NavbarMenu";
import appInbox from "./screens/App/Inbox";
import appChat from "./screens/App/Chat";
import appCalendar from "./screens/App/Calendar";
import appContact from "./screens/App/Contact";
import appTaskbar from "./screens/App/Taskbar";
import filemanagerdashboard from "./screens/FileManager/Dashboard";
import filedocuments from "./screens/FileManager/Documents";
import filemedia from "./screens/FileManager/Media";
import fileimages from "./screens/FileManager/Images";
import blognewPost from "./screens/Blog/NewPost";
import blogdetails from "./screens/Blog/BlogDetails";
import bloglist from "./screens/Blog/BlogList";
import uitypography from "./screens/UIElements/Typography";
import uitabs from "./screens/UIElements/Tabs";
import uibuttons from "./screens/UIElements/Button";
import bootstrapui from "./screens/UIElements/BootstrapUI";
import uiicons from "./screens/UIElements/Icons";
import uinotifications from "./screens/UIElements/Notifications";
import uicolors from "./screens/UIElements/Colors";
import uilistgroup from "./screens/UIElements/ListGroup";
import uimediaobject from "./screens/UIElements/MediaObject";
import uimodal from "./screens/UIElements/Modals";
import uiprogressbar from "./screens/UIElements/ProgressBar";
import widgetsdata from "./screens/Widgets/Data";
import widgetsweather from "./screens/Widgets/Weather";
import widgetsblog from "./screens/Widgets/Blog";
import widgetsecommers from "./screens/Widgets/ECommers";
import registration from "./screens/Auth/Registration";
import lockscreen from "./screens/Auth/Lockscreen";
import forgotpassword from "./screens/Auth/ForgotPassword";
import page404 from "./screens/Auth/Page404";
import page403 from "./screens/Auth/Page403";
import page500 from "./screens/Auth/Page500";
import page503 from "./screens/Auth/Page503";
import blankpage from "./screens/Pages/BlankPage";
import profilev1page from "./screens/Pages/ProfileV1";
import profilev2page from "./screens/Pages/ProfileV2";
import imagegalleryprofile from "./screens/Pages/ImageGallery";
import timeline from "./screens/Pages/TimeLine";
import pricing from "./screens/Pages/Pricing";
import invoices from "./screens/Pages/Invoices";
import invoicesv2 from "./screens/Pages/InvoicesV2";
import searchresult from "./screens/Pages/SearchResults";
import helperclass from "./screens/Pages/HelperClass";
import teamsboard from "./screens/Pages/TeamsBoard";
import projectslist from "./screens/Pages/ProjectsList";
import maintanance from "./screens/Pages/Maintanance";
import testimonials from "./screens/Pages/Testimonials";
import faqs from "./screens/Pages/Faqs";

import basicelements from "./screens/Forms/BasicElements";
import tablenormal from "./screens/Tables/TableNormal";
import TableCategoryNews from "./screens/Tables/TableCategoryNews";
import echart from "./screens/Charts/Echart";
import leafletmap from "./screens/Maps/GoogleMaps";
import EditForm from "./screens/Forms/EditForm";
import FormAddDirectory from "./screens/Forms/FormAddDirectory";
import FormAddCategory from "./screens/Forms/FormAddCategory";
import EditCategory from "./screens/Forms/FormEditCategory";
import FormEditCategory from "./screens/Forms/FormEditCategory";
import TableNews from "./screens/Tables/TableNews";
import FormAddNews from "./screens/Forms/FormAddNews";
import EditNews from "./screens/Forms/FormEditNews";
import FormEditNews from "./screens/Forms/FormEditNews";
import TableCategoryEvents from "./screens/Tables/TableCategoryEvents";
import FormEventsAddCategory from "./screens/Forms/FormEventsAddCategory";
import FormAddEvents from "./screens/Forms/FormAddEvents";
import TableEvents from "./screens/Tables/TableEvents";
import FormEditEventsCategory from "./screens/Forms/FormEditEventsCategory";
import FormEditEvents from "./screens/Forms/FormEditEvents";
import FormAddKuldevi from "./screens/Forms/FormAddKuldevi";
import TableKuldevi from "./screens/Tables/TableKuldevi";
import FormEditKuldevi from "./screens/Forms/FormEditKuldevi";
import TableBloodZoneList from "./screens/Tables/TableBloodZoneList";
import FormAddRasam from "./screens/Forms/FormAddRasam";
import TableRasam from "./screens/Tables/TableRasam";
import FormEditRasam from "./screens/Forms/FormEditRasam";
import FormAddClassifiedCategory from "./screens/Forms/FormAddClassifiedCategory";
import TableClassifiedCategory from "./screens/Tables/TableClassifiedCategory";
import FormEditClassifiedCategory from "./screens/Forms/FormEditClassifiedCategory";
import FormAddClassified from "./screens/Forms/FormAddClassified";
import TableClassified from "./screens/Tables/TableClassified";
import FormEditClassified from "./screens/Forms/FormEditClassified";
import TableBusinessDirectory from "./screens/Tables/TableBusinessDirectory";
import FormAddBusinessNetworkCategory from "./screens/Forms/FormAddBusinessNetworkCategory";
import TableBusinessNetworkCategory from "./screens/Tables/TableBusinessNetworkCategory";
import FormAddBusinessNetwork from "./screens/Forms/FormAddBusinessNetwork";
import TableBusinessNetwork from "./screens/Tables/TableBusinessNetwork";
import FormEditBusinessNetworkCategory from "./screens/Forms/FormEditBusinessNetworkCategory";
import FormEditBusinessNetwork from "./screens/Forms/FormEditBusinessNetwork";
import TableCategoryKuldevi from "./screens/Tables/TableCategoryKuldevi";
import TableCategoryRasam from "./screens/Tables/TableCategoryRasam";
import FormAddKuldeviCategory from "./screens/Forms/FormAddKuldeviCategory";
import FormAddRasamCategory from "./screens/Forms/FormAddRasamCategory";
import FormEditKuldeviCategory from "./screens/Forms/FormEditKuldeviCategory";
import FormEditRasamCategory from "./screens/Forms/FormEditRasamCategory";
import TableBloodBank from "./screens/Tables/TableBloodBank";
import FormAddBloodBank from "./screens/Forms/FormAddBloodBank";
import FormEditBloodBank from "./screens/Forms/FormEditBloodBank";
import FormAddCategoryVrat from "./screens/Forms/FormAddCategoryVrat";
import TableCategoryVrat from "./screens/Tables/TableCategoryVrat";
import FormEditVratCategory from "./screens/Forms/FormEditVratCategory";
import FormAddVrat from "./components/Forms/FormAddVrat";
import TableVrat from "./screens/Tables/TableVrat";
import FormEditVrat from "./screens/Forms/FormEditVrat";
import FormAddAchiversCategory from "./screens/Forms/FormAddAchiversCategory";
import TableAchiversCategory from "./screens/Tables/TableAchiversCategory";
import FormEditAchiversCategory from "./screens/Forms/FormEditAchiversCategory";
import FormAddArchivers from "./screens/Forms/FormAddArchivers";
import TableAchivers from "./screens/Tables/TableAchivers";
import FormEditAchivers from "./screens/Forms/FormEditAchivers";
import TableJobs from "./screens/Tables/TableJobs";
import FormAddJobs from "./screens/Forms/FormAddJobs";
import FormEditJobs from "./screens/Forms/FormEditJobs";
import TableGallery from "./screens/Tables/TableGallery";
import FormAddGallery from "./screens/Forms/FormAddGallery";
import FormEditGallery from "./screens/Forms/FormEditGallery";
import FormAddSubCategoryVrat from "./screens/Forms/FormAddSubCategoryVrat";
import TableSubCategoryVrat from "./screens/Tables/TableSubCategoryVrat";
import FromEditVratSubCategory from "./screens/Forms/FromEditVratSubCategory";
import TableCategoryGallery from "./screens/Tables/TableCategoryGallery";
import FormAddCategoryGallery from "./screens/Forms/FormAddCategoryGallery";
import FormEditCategoryGallery from "./screens/Forms/FormEditCategoryGallery";
import TableVolunteers from "./screens/Tables/TableVolunteers";
import FormAddVolunteers from "./screens/Forms/FormAddVolunteers";
import FormEditVolunteers from "./screens/Forms/FormEditVolunteers";
import FormAddOrganisations from "./screens/Forms/FormAddOrganisations";
import TableOrganisations from "./screens/Tables/TableOrganisations";
import FormEditOrganisations from "./screens/Forms/FormEditOrganisations";
import FormAddDonation from "./screens/Forms/FormAddDonation";
import TableDonationList from "./screens/Tables/TableDonationList";
import FormEditDonation from "./screens/Forms/FormEditDonation";
import FormAddSubSubCategoryVrat from "./screens/Forms/FormAddSubSubCategoryVrat";
import TableSubSubCategoryVrat from "./screens/Tables/TableSubSubCategoryVrat";
import FromEditVratSubSubCategory from "./screens/Forms/FromEditVratSubSubCategory";
import PrivateRoute from "./auth";
import FormAddPanditJiCategory from "./screens/Forms/FormAddPanditJiCategory";
import TablePanditjiCategory from "./screens/Tables/TablePanditjiCategory";
import FormEditPanditjiCategory from "./screens/Forms/FormEditPanditjiCategory";
import TablePanditjiList from "./screens/Tables/TablePanditjiList";
import FormAddPackage from "./screens/Forms/FormAddPackage";
import TablePackagesList from "./screens/Tables/TablePackagesList";
import FormEditPackages from "./screens/Forms/FormEditPackages";
import FormAddMatrimonyPackages from "./screens/Forms/FormAddMatrimonyPackages";
import TableMatrimonyPackages from "./screens/Tables/TableMatrimonyPackages";
import FormEditMatrimonyPackages from "./screens/Forms/FormEditMatrimonyPackages";
import FormAddMatrimony from "./screens/Forms/FormAddMatrimony";
import TableMatrimony from "./screens/Tables/TableMatrimony";
import TableMatrimonyRequest from "./screens/Tables/TableMatrimonyRequest";
import EditMatrimony from "./screens/Forms/FormEditMatrimony";
import FormEditMatrimony from "./screens/Forms/FormEditMatrimony";
import FormAddCaste from "./screens/Forms/FormAddCaste";
import TableCaste from "./screens/Tables/TableCaste";
import FormEditCaste from "./screens/Forms/FormEditCaste";
import FormAddJobCategory from "./screens/Forms/FormAddJobCategory";
import TableJobCategory from "./screens/Tables/TableJobCategory";
import FormEditJobCategory from "./screens/Forms/FormEditJobCategory";
import FormAddTopBanner from "./screens/Forms/FormAddTopBanner";
import TableTopBanner from "./screens/Tables/TableTopBanner";
import EditTopBanner from "./screens/Forms/FormEditTopBanner";
import FormEditTopBanner from "./screens/Forms/FormEditTopBanner";
import FormAddBottomBanner from "./screens/Forms/FormAddBottomBanner";
import TableBottomBanner from "./screens/Tables/TableBottomBanner";
import FormEditBottomBanner from "./screens/Forms/FormEditBottomBanner";
import FormAddMagzines from "./screens/Forms/FormAddMagzines";
import TableMagazines from "./screens/Tables/TableMagazines";
import FormEditMagazines from "./screens/Forms/FormEditMagazines";
import TableUserSuggestionsList from "./screens/Tables/TableUserSuggestionsList";
import FormAddContent from "./screens/Forms/FormAddContent";
import TableContent from "./screens/Tables/TableContent";
import FormEditContent from "./screens/Forms/FormEditContent";



window.__DEV__ = true;

class App extends React.Component {
  
  constructor(props) {
      // useEffect(() => {
      //   setupAxiosInterceptors(props.history);
      // }, [props.history]);
    console.warn = () => { }
    super(props);
    this.state = {
      isLoad: true,
    };

    setupAxiosInterceptors(props.history);
  }
  render() {

    var res = window.location.pathname;
    var baseUrl = process.env.PUBLIC_URL;
    baseUrl = baseUrl.split("/");
    res = res.split("/");
    res = res.length > 0 ? res[baseUrl.length] : "/";
    res = res ? res : "/";
    const activeKey1 = res;



    return (
      <div id="wrapper">
        {activeKey1 === "" ||
          activeKey1 === "/" ||
          activeKey1 === "login" ||
          activeKey1 === "registration" ||
          activeKey1 === "lockscreen" ||
          activeKey1 === "forgotpassword" ||
          activeKey1 === "page404" ||
          activeKey1 === "page403" ||
          activeKey1 === "page500" ||
          activeKey1 === "page503" ||
          activeKey1 === "maintanance" ? (
          <Switch>
            {/* <Route exact path={`${process.env.PUBLIC_URL}`} component={Login} /> */}
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/`}
              component={Login}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/login`}
              component={Login}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/forgotpassword`}
              component={forgotpassword}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/page404`}
              component={page404}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/page403`}
              component={page403}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/page500`}
              component={page500}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/page503`}
              component={page503}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/registration`}
              component={registration}
            />
            <Route exact path={`registration`} component={registration} />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/lockscreen`}
              component={lockscreen}
            />
            <Route
              exact
              path={`${process.env.PUBLIC_URL}/maintanance`}
              component={maintanance}
            />
          </Switch>
        ) : (
          <>
            <NavbarMenu history={this.props.history} activeKey={activeKey1} />
            <div id="main-content">
              <Switch>
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/dashboard`}
                  component={dashboard}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/demographic`}
                  component={demographic}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/ioT`}
                  component={ioT}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/appinbox`}
                  component={appInbox}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/appchat`}
                  component={appChat}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/appcalendar`}
                  component={appCalendar}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/appcontact`}
                  component={appContact}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/apptaskbar`}
                  component={appTaskbar}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/filemanagerdashboard`}
                  component={filemanagerdashboard}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/filedocuments`}
                  component={filedocuments}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/filemedia`}
                  component={filemedia}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/fileimages`}
                  component={fileimages}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/blognewpost`}
                  component={blognewPost}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/blogdetails`}
                  component={blogdetails}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/bloglist`}
                  component={bloglist}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/uitypography`}
                  component={uitypography}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/uitabs`}
                  component={uitabs}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/bootstrapui`}
                  component={bootstrapui}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/uiicons`}
                  component={uiicons}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/uinotifications`}
                  component={uinotifications}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/uicolors`}
                  component={uicolors}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/uilistgroup`}
                  component={uilistgroup}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/uimediaobject`}
                  component={uimediaobject}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/uimodal`}
                  component={uimodal}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/uibuttons`}
                  component={uibuttons}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/uiprogressbar`}
                  component={uiprogressbar}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/widgetsdata`}
                  component={widgetsdata}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/widgetsweather`}
                  component={widgetsweather}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/widgetsblog`}
                  component={widgetsblog}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/widgetsecommers`}
                  component={widgetsecommers}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/blankpage`}
                  component={blankpage}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/profilev1page`}
                  component={profilev1page}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/profilev2page`}
                  component={profilev2page}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/imagegalleryprofile`}
                  component={imagegalleryprofile}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/timeline`}
                  component={timeline}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/pricing`}
                  component={pricing}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/invoices`}
                  component={invoices}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/invoicesv2`}
                  component={invoicesv2}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/searchresult`}
                  component={searchresult}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/helperclass`}
                  component={helperclass}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/teamsboard`}
                  component={teamsboard}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/projectslist`}
                  component={projectslist}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/testimonials`}
                  component={testimonials}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/faqs`}
                  component={faqs}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/formvalidation`}
                  component={FormAddDirectory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addcaste`}
                  component={FormAddCaste}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/casteList`}
                  component={TableCaste}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editcaste/:id`}
                  component={FormEditCaste}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addcategory`}
                  component={FormAddCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addnews`}
                  component={FormAddNews}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/edit/:id`}
                  component={EditForm}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editcategory/:id`}
                  component={FormEditCategory}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/add-content`}
                  component={FormAddContent}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/list-content`}
                  component={TableContent}
                />
                   <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/edit-content/:id`}
                  component={FormEditContent}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editnews/:id`}
                  component={FormEditNews}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addeventscategory`}
                  component={FormEventsAddCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addkuldevicategory`}
                  component={FormAddKuldeviCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addRasamRiwajcategory`}
                  component={FormAddRasamCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addevents`}
                  component={FormAddEvents}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editeventscategory/:id`}
                  component={FormEditEventsCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editkuldevicategory/:id`}
                  component={FormEditKuldeviCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editrasamcategory/:id`}
                  component={FormEditRasamCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editclassifiedcategory/:id`}
                  component={FormEditClassifiedCategory}
                />

                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editevents/:id`}
                  component={FormEditEvents}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editkuldevi/:id`}
                  component={FormEditKuldevi}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editrasam/:id`}
                  component={FormEditRasam}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editclassified/:id`}
                  component={FormEditClassified}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editBusinessNetworkcategory/:id`}
                  component={FormEditBusinessNetworkCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editBusinessNetwork/:id`}
                  component={FormEditBusinessNetwork}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/bloodzone`}
                  component={TableBloodZoneList}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/bloodbank`}
                  component={TableBloodBank}
                />

                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addbloodbank`}
                  component={FormAddBloodBank}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editbloodbankdetails/:id`}
                  component={FormEditBloodBank}
                />

                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/vratAurTyoharaddcategory`}
                  component={FormAddCategoryVrat}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/vratAurTyoharaddsubcategory`}
                  component={FormAddSubCategoryVrat}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/vratAurTyoharaddsubsubcategory`}
                  component={FormAddSubSubCategoryVrat}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/vratAurTyoharcategory`}
                  component={TableCategoryVrat}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/vratAurTyoharsubcategory`}
                  component={TableSubCategoryVrat}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/vratAurTyoharsubsubcategory`}
                  component={TableSubSubCategoryVrat}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editvratcategory/:id`}
                  component={FormEditVratCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editvratsubcategory/:id`}
                  component={FromEditVratSubCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editvratsubsubcategory/:id`}
                  component={FromEditVratSubSubCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addVratAurTyohar`}
                  component={FormAddVrat}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/vratAurTyoharlist`}
                  component={TableVrat}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editvrat/:id`}
                  component={FormEditVrat}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addachiverscategory`}
                  component={FormAddAchiversCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/achiverscategory`}
                  component={TableAchiversCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editachiverscategory/:id`}
                  component={FormEditAchiversCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addachivers`}
                  component={FormAddArchivers}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/achiverslist`}
                  component={TableAchivers}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editachivers/:id`}
                  component={FormEditAchivers}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/jobscategorylist`}
                  component={TableJobCategory}
                />

                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addjobscategory`}
                  component={FormAddJobCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editjobscategory/:id`}
                  component={FormEditJobCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/jobslist`}
                  component={TableJobs}
                />

                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addjobs`}
                  component={FormAddJobs}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editjobs/:id`}
                  component={FormEditJobs}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/gallerylist`}
                  component={TableGallery}
                />

                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addgallery`}
                  component={FormAddGallery}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editgallery/:id`}
                  component={FormEditGallery}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/gallerycategorylist`}
                  component={TableCategoryGallery}
                />

                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addgallerycategory`}
                  component={FormAddCategoryGallery}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editgallerycategory/:id`}
                  component={FormEditCategoryGallery}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/volunteersorcommittee`}
                  component={TableVolunteers}
                />

                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addvolunteersorcommittee`}
                  component={FormAddVolunteers}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editvolunteersorcommittee/:id`}
                  component={FormEditVolunteers}
                />
                  <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addoptionscategory`}
                  component={FormAddPanditJiCategory}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/optionscategory`}
                  component={TablePanditjiCategory}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editoptionscategory/:id`}
                  component={FormEditPanditjiCategory}
                />
                  <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/optionslist`}
                  component={TablePanditjiList}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/basicelements`}
                  component={basicelements}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/tablenormal`}
                  component={tablenormal}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/tablenormalbusiness`}
                  component={TableBusinessDirectory}
                />
                <PrivateRoute 
                  exact
                  path={`${process.env.PUBLIC_URL}/eventscategory`}
                  component={TableCategoryEvents}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/kuldevicategory`}
                  component={TableCategoryKuldevi}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/rasamriwajcategory`}
                  component={TableCategoryRasam}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/eventslist`}
                  component={TableEvents}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/newscategory`}
                  component={TableCategoryNews}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/newslist`}
                  component={TableNews}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addkuldevidevata`}
                  component={FormAddKuldevi}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/kuldevidevatalist`}
                  component={TableKuldevi}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addrasamaurriwaj`}
                  component={FormAddRasam}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/rasamaurriwajlist`}
                  component={TableRasam}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addclassifiedcategory`}
                  component={FormAddClassifiedCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/classifiedcategorylist`}
                  component={TableClassifiedCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addclassified`}
                  component={FormAddClassified}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/classifiedlist`}
                  component={TableClassified}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addBusinessNetworkcategory`}
                  component={FormAddBusinessNetworkCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/businessNetworkcategorylist`}
                  component={TableBusinessNetworkCategory}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addBusinessNetwork`}
                  component={FormAddBusinessNetwork}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/businessNetworklist`}
                  component={TableBusinessNetwork}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addorganisations`}
                  component={FormAddOrganisations}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/organisationslist`}
                  component={TableOrganisations}
                />
                  <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editorganisations/:id`}
                  component={FormEditOrganisations}
                />
                  <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addDonation`}
                  component={FormAddDonation}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/donationlist`}
                  component={TableDonationList}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editdonation/:id`}
                  component={FormEditDonation}
                />
                  <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addpackages`}
                  component={FormAddPackage}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/packageslist`}
                  component={TablePackagesList}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editpackages/:id`}
                  component={FormEditPackages}
                />
                  <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addmatrimonypackages`}
                  component={FormAddMatrimonyPackages}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/matrimonypackageslist`}
                  component={TableMatrimonyPackages}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editmatrimonypackages/:id`}
                  component={FormEditMatrimonyPackages}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addmatrimony`}
                  component={FormAddMatrimony}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/matrimonylist`}
                  component={TableMatrimony}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/editmatrimony/:id`}
                  component={FormEditMatrimony}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/matrimonyrequestlist`}
                  component={TableMatrimonyRequest}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/addtopbanner`}
                  component={FormAddTopBanner}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/topbannerlist`}
                  component={TableTopBanner}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/edittopbanner/:id`}
                  component={FormEditTopBanner}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/add-sponsor`}
                  component={FormAddBottomBanner
                  }
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/sponsor-list`}
                  component={TableBottomBanner}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/edit-sponsor/:id`}
                  component={FormEditBottomBanner}
                />
                  <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/add-magazines`}
                  component={FormAddMagzines}
                />
                  <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/magazines-list`}
                  component={TableMagazines}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/edit-magazines/:id`}
                  component={FormEditMagazines}
                />
                 <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/suggestions-list`}
                  component={TableUserSuggestionsList}
                />
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/echart`}
                  component={echart}
                />
                
                <PrivateRoute
                  exact
                  path={`${process.env.PUBLIC_URL}/leafletmap`}
                  component={leafletmap}
                />
             
                
              </Switch>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ loginReducer }) => ({
  isLoggedin: loginReducer.isLoggedin,
});

export default withRouter(connect(mapStateToProps, {})(App));
